module.exports = "pegasus/assets/email1-logo.png";